export default __webpack_public_path__ + "static/media/running_man_pers.fb318d6e.svg";